/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2
// Component: KxFKYkrIRubG

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import {
  executePlasmicDataOp,
  usePlasmicDataOp,
  usePlasmicInvalidate
} from "@plasmicapp/react-web/lib/data-sources";

import { RealtimeStatusIndicator } from "@/components/RealtimeStatusIndicator"; // plasmic-import: ZQNpoUOQBr81/codeComponent
import NotificationCenter2 from "../../NotificationCenter2"; // plasmic-import: lus6OgZNeC63/component
import { SupabaseRpcProvider } from "@/components/SupabaseRpcProvider"; // plasmic-import: A8CjdIiUkA4q/codeComponent
import { AntdButton } from "@plasmicpkgs/antd5/skinny/registerButton";
import { AntdCheckbox } from "@plasmicpkgs/antd5/skinny/registerCheckbox";
import LinkCard from "../../LinkCard"; // plasmic-import: 7rG0DYfwVULy/component
import { AntdMenu } from "@plasmicpkgs/antd5/skinny/registerMenu";
import { AntdSubMenu } from "@plasmicpkgs/antd5/skinny/registerMenu";
import { AntdMenuItem } from "@plasmicpkgs/antd5/skinny/registerMenu";
import { NavigationShell } from "@/components/NavigationShell"; // plasmic-import: YCflx5AB6pyF/codeComponent
import { GlobalSupabaseFetchConfig } from "@/components/GlobalSupabaseFetchConfig"; // plasmic-import: nno9Wg60sMaH/codeComponent
import ReportIssue from "../../ReportIssue"; // plasmic-import: _9iHutwm7rWJ/component
import AiChat from "../../AiChat"; // plasmic-import: 0si8oZstPWru/component
import { SideEffect } from "@plasmicpkgs/plasmic-basic-components";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/styleTokensProvider


import sty from "./PlasmicLayout2.module.css"; // plasmic-import: KxFKYkrIRubG/css

import PrintTransparentNobufferBlueishSvgIcon from "./icons/PlasmicIcon__PrintTransparentNobufferBlueishSvg"; // plasmic-import: rAWTkVRs0YEx/icon
import CogGearSvgrepoComSvgIcon from "./icons/PlasmicIcon__CogGearSvgrepoComSvg"; // plasmic-import: 6Nd9soj_HeYj/icon
import CheckSvgIcon from "../plasmic_tabs/icons/PlasmicIcon__CheckSvg"; // plasmic-import: zq2s7N0xWucT/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: z99EqToZO7vk/icon

createPlasmicElementProxy;

export type PlasmicLayout2__VariantMembers = {
  topBar: "topBar";
  hidden: "hidden";
  toggle: "toggle";
  darkMode: "darkMode";
};
export type PlasmicLayout2__VariantsArgs = {
  topBar?: SingleBooleanChoiceArg<"topBar">;
  hidden?: SingleBooleanChoiceArg<"hidden">;
  toggle?: SingleBooleanChoiceArg<"toggle">;
  darkMode?: SingleBooleanChoiceArg<"darkMode">;
};
type VariantPropType = keyof PlasmicLayout2__VariantsArgs;
export const PlasmicLayout2__VariantProps = new Array<VariantPropType>(
  "topBar",
  "hidden",
  "toggle",
  "darkMode"
);

export type PlasmicLayout2__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicLayout2__ArgsType;
export const PlasmicLayout2__ArgProps = new Array<ArgPropType>("children");

export type PlasmicLayout2__OverridesType = {
  root?: Flex__<"div">;
  container?: Flex__<"div">;
  h5?: Flex__<"h5">;
  supabaseRpcProvider?: Flex__<typeof SupabaseRpcProvider>;
  button?: Flex__<typeof AntdButton>;
  customer?: Flex__<"nav">;
  checkbox?: Flex__<typeof AntdCheckbox>;
  linkCard?: Flex__<typeof LinkCard>;
  myMenu?: Flex__<typeof AntdMenu>;
  subMenu?: Flex__<typeof AntdSubMenu>;
  navigationShell?: Flex__<typeof NavigationShell>;
  globalSupabaseFetchConfigInitializer?: Flex__<
    typeof GlobalSupabaseFetchConfig
  >;
  reportIssue?: Flex__<typeof ReportIssue>;
  aiChat?: Flex__<typeof AiChat>;
  sideEffect?: Flex__<typeof SideEffect>;
};

export interface DefaultLayout2Props {
  children?: React.ReactNode;
  topBar?: SingleBooleanChoiceArg<"topBar">;
  hidden?: SingleBooleanChoiceArg<"hidden">;
  toggle?: SingleBooleanChoiceArg<"toggle">;
  darkMode?: SingleBooleanChoiceArg<"darkMode">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLayout2__RenderFunc(props: {
  variants: PlasmicLayout2__VariantsArgs;
  args: PlasmicLayout2__ArgsType;
  overrides: PlasmicLayout2__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "navMenu",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return (() => {
                return [
                  "account",
                  "",
                  "receiving",
                  "battery&polishp",
                  "polish",
                  "paint",
                  "search",
                  "packing",
                  "reprint",
                  "phone-parts",
                  "technician",
                  "daily-report",
                  "see-reports",
                  "assign-jobs",
                  "repair-summary",
                  "grading"
                ];
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return {};
              }
              throw e;
            }
          })()
      },
      {
        path: "hoveredButtonUser",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => -1
      },
      {
        path: "topBar",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return (() => {
                let a = $ctx.layout ?? { panel_access: ["*"] };
                return !a.panel_access.includes("*");
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })() ?? $props.topBar
      },
      {
        path: "hidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hidden
      },
      {
        path: "toggle",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.toggle
      },
      {
        path: "variable",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "checkbox[].checked",
        type: "private",
        variableType: "boolean"
      },
      {
        path: "userPrefs",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return (() => {
                if (typeof window !== "undefined") {
                  return JSON.parse(localStorage.getItem("UserPrefs"));
                }
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return {};
              }
              throw e;
            }
          })()
      },
      {
        path: "test",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $state.userPrefs.hiddenMenus ?? [];
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()
      },
      {
        path: "editMode",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "darkMode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.darkMode
      },
      {
        path: "loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $globalActions = useGlobalActions?.();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const dataSourcesCtx = usePlasmicDataSourceContext();
  const plasmicInvalidate = usePlasmicInvalidate();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.roottoggle]: hasVariant($state, "toggle", "toggle"),
          [sty.roottopBar]: hasVariant($state, "topBar", "topBar")
        }
      )}
    >
      <section
        className={classNames("all", sty.section__zis6J, {
          [sty.sectiontoggle__zis6JdZfgw]: hasVariant(
            $state,
            "toggle",
            "toggle"
          ),
          [sty.sectiontopBar__zis6Jpc8We]: hasVariant(
            $state,
            "topBar",
            "topBar"
          )
        })}
      >
        <div
          className={classNames("all", sty.freeBox__sQVC, {
            [sty.freeBoxtoggle__sQVCdZfgw]: hasVariant(
              $state,
              "toggle",
              "toggle"
            ),
            [sty.freeBoxtopBar__sQVCpc8We]: hasVariant(
              $state,
              "topBar",
              "topBar"
            ),
            [sty.freeBoxtopBar_toggle__sQVCpc8WeDZfgw]:
              hasVariant($state, "topBar", "topBar") &&
              hasVariant($state, "toggle", "toggle")
          })}
        >
          {false ? (
            <div
              data-plasmic-name={"container"}
              data-plasmic-override={overrides.container}
              className={classNames("all", sty.container, {
                [sty.containerhidden]: hasVariant($state, "hidden", "hidden"),
                [sty.containertoggle]: hasVariant($state, "toggle", "toggle"),
                [sty.containertopBar]: hasVariant($state, "topBar", "topBar"),
                [sty.containertopBar_toggle]:
                  hasVariant($state, "topBar", "topBar") &&
                  hasVariant($state, "toggle", "toggle")
              })}
            >
              <RealtimeStatusIndicator
                className={classNames(
                  "__wab_instance",
                  sty.realtimeStatusIndicator__iIaxy
                )}
              />

              <PrintTransparentNobufferBlueishSvgIcon
                className={classNames("all", sty.svg___9YvkZ)}
                role={"img"}
              />

              <NotificationCenter2
                className={classNames(
                  "__wab_instance",
                  sty.notificationCenter2__ahWpw,
                  {
                    [sty.notificationCenter2topBar__ahWpwPc8We]: hasVariant(
                      $state,
                      "topBar",
                      "topBar"
                    )
                  }
                )}
              />

              {(() => {
                try {
                  return (
                    $ctx.layout.uuid != "267c3aaa-53f6-46cc-b550-eb72458008a5"
                  );
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return true;
                  }
                  throw e;
                }
              })() ? (
                <div className={classNames("all", sty.freeBox__tjSmh)}>
                  <h5
                    data-plasmic-name={"h5"}
                    data-plasmic-override={overrides.h5}
                    className={classNames(
                      "all",
                      "h5",
                      "h5__k4MoY",
                      "__wab_text",
                      sty.h5,
                      { [sty.h5topBar]: hasVariant($state, "topBar", "topBar") }
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobileOnly") ? (
                      <React.Fragment>
                        {(() => {
                          try {
                            return (() => {
                              const resolved = $ctx.layout;
                              console.log(
                                "[Name] Right now the $ctx.layout.name is " +
                                  $ctx.layout.name
                              );
                              return "Welcome";
                            })();
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return "Please log in";
                            }
                            throw e;
                          }
                        })()}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {(() => {
                          try {
                            return (() => {
                              const resolved = $ctx.layout;
                              console.log(
                                "[Name] Right now the $ctx.layout.name is " +
                                  $ctx.layout.name
                              );
                              return "Welcome " + resolved.name;
                            })();
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return "Please log in";
                            }
                            throw e;
                          }
                        })()}
                      </React.Fragment>
                    )}
                  </h5>
                  <SupabaseRpcProvider
                    data-plasmic-name={"supabaseRpcProvider"}
                    data-plasmic-override={overrides.supabaseRpcProvider}
                    alwaysClient={false}
                    blockingLoad={false}
                    className={classNames(
                      "__wab_instance",
                      sty.supabaseRpcProvider
                    )}
                    disableLocalStorageCache={false}
                    realtimeTriggerTables={[]}
                    rpcName={"get_my_sessions"}
                  >
                    <DataCtxReader__>
                      {$ctx =>
                        (() => {
                          try {
                            return $ctx.get_my_sessions.length > 0;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames("all", sty.freeBox__o9Won)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__zdh5C,
                                {
                                  [sty.texttopBar__zdh5CPc8We]: hasVariant(
                                    $state,
                                    "topBar",
                                    "topBar"
                                  )
                                }
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return (
                                      $ctx.get_my_sessions.length +
                                      " People with your account"
                                    );
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "2 People with your account";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </div>
                            {(_par =>
                              !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                              (() => {
                                try {
                                  return $ctx.get_my_sessions;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return [];
                                  }
                                  throw e;
                                }
                              })()
                            ).map((__plasmic_item_0, __plasmic_idx_0) => {
                              const currentItem = __plasmic_item_0;
                              const currentIndex = __plasmic_idx_0;
                              return (
                                <div
                                  className={classNames(
                                    "all",
                                    sty.freeBox__cepbb
                                  )}
                                  key={currentIndex}
                                >
                                  <div
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.text__ne0IS
                                    )}
                                  >
                                    <React.Fragment>
                                      {(() => {
                                        try {
                                          return new Date(
                                            currentItem.created_at
                                          ).toLocaleString();
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return "";
                                          }
                                          throw e;
                                        }
                                      })()}
                                    </React.Fragment>
                                  </div>
                                </div>
                              );
                            })}
                            <AntdButton
                              data-plasmic-name={"button"}
                              data-plasmic-override={overrides.button}
                              className={classNames(
                                "__wab_instance",
                                sty.button
                              )}
                              danger={true}
                              onClick={async () => {
                                const $steps = {};

                                $steps["invokeGlobalAction"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        args: ["others", true]
                                      };
                                      return $globalActions[
                                        "SupabaseActions.logout"
                                      ]?.apply(null, [...actionArgs.args]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["invokeGlobalAction"] != null &&
                                  typeof $steps["invokeGlobalAction"] ===
                                    "object" &&
                                  typeof $steps["invokeGlobalAction"].then ===
                                    "function"
                                ) {
                                  $steps["invokeGlobalAction"] =
                                    await $steps["invokeGlobalAction"];
                                }

                                $steps["refreshData"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        queryInvalidation: [
                                          "plasmic_refresh_all"
                                        ]
                                      };
                                      return (async ({ queryInvalidation }) => {
                                        if (!queryInvalidation) {
                                          return;
                                        }
                                        await plasmicInvalidate(
                                          queryInvalidation
                                        );
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["refreshData"] != null &&
                                  typeof $steps["refreshData"] === "object" &&
                                  typeof $steps["refreshData"].then ===
                                    "function"
                                ) {
                                  $steps["refreshData"] =
                                    await $steps["refreshData"];
                                }
                              }}
                              type={"default"}
                            >
                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__yfZzw
                                )}
                              >
                                {"Log out"}
                              </div>
                            </AntdButton>
                          </div>
                        ) : null
                      }
                    </DataCtxReader__>
                  </SupabaseRpcProvider>
                </div>
              ) : null}
              {false ? (
                <nav
                  data-plasmic-name={"customer"}
                  data-plasmic-override={overrides.customer}
                  className={classNames("all", sty.customer, {
                    [sty.customertoggle]: hasVariant(
                      $state,
                      "toggle",
                      "toggle"
                    ),
                    [sty.customertopBar]: hasVariant($state, "topBar", "topBar")
                  })}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return (() => {
                          let mydefault = [
                            "account",
                            "home",
                            "receiving",
                            "receiving-2",
                            "battery",
                            "rework",
                            "glass",
                            "polish-plus",
                            "polish",
                            "project",
                            "paint",
                            "body",
                            "search",
                            "packing",
                            "reprint",
                            "phone-parts",
                            "technician",
                            "daily-report",
                            "see-reports",
                            "assign-jobs",
                            "bins-overview",
                            "my-bins",
                            "repair-summary",
                            "grading",
                            "calendar",
                            "outside-repair",
                            "supplies",
                            "manage-users",
                            "manage-employees",
                            "timesheet",
                            "searching-bodies",
                            "employee-repair",
                            "vacation-form",
                            "technician-damages",
                            "moe"
                          ];

                          mydefault = !$state.editMode
                            ? mydefault.filter(
                                item => !$state.test.includes(item)
                              )
                            : mydefault;
                          const resolved = $ctx.layout ?? [];
                          const accessList = resolved.panel_access.includes("*")
                            ? mydefault
                            : resolved.panel_access.filter(p =>
                                mydefault.includes(p)
                              );
                          function formatter(str) {
                            if (!str || str.trim() === "") return "Home";
                            return str
                              .replace(/&/g, " & ")
                              .replace(/-/g, " ")
                              .split(/\s+/)
                              .map(
                                word =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              )
                              .join(" ");
                          }
                          const finalPanels = accessList.map(item => ({
                            destiny: "/" + item,
                            preview: "/" + item,
                            title: formatter(item).replace(
                              "Reports",
                              "Tickets"
                            ),
                            props: resolved?.panel_access_data?.[item] ?? {}
                          }));
                          return finalPanels;
                        })();
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <div
                        className={classNames("all", sty.freeBox__ukhYr, {
                          [sty.freeBoxtopBar__ukhYrpc8We]: hasVariant(
                            $state,
                            "topBar",
                            "topBar"
                          )
                        })}
                        key={currentIndex}
                      >
                        {(() => {
                          try {
                            return $state.editMode;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })()
                          ? (() => {
                              const child$Props = {
                                checked: generateStateValueProp($state, [
                                  "checkbox",
                                  __plasmic_idx_0,
                                  "checked"
                                ]),
                                children: null,
                                className: classNames(
                                  "__wab_instance",
                                  sty.checkbox
                                ),
                                defaultChecked: (() => {
                                  try {
                                    return (() => {
                                      let a =
                                        $state.userPrefs.hiddenMenus ?? [];
                                      let answer = a.findIndex(
                                        item =>
                                          item ==
                                          currentItem.destiny.replace("/", "")
                                      );
                                      return answer != -1;
                                    })();
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return false;
                                    }
                                    throw e;
                                  }
                                })(),
                                onChange: async (...eventArgs: any) => {
                                  generateStateOnChangeProp($state, [
                                    "checkbox",
                                    __plasmic_idx_0,
                                    "checked"
                                  ]).apply(null, eventArgs);

                                  (async checked => {
                                    const $steps = {};

                                    $steps["updateTest"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            variable: {
                                              objRoot: $state,
                                              variablePath: ["test"]
                                            },
                                            operation: 0,
                                            value: (() => {
                                              let a = new Set($state.test);
                                              if (checked ?? false) {
                                                a.add(
                                                  currentItem.destiny.replace(
                                                    "/",
                                                    ""
                                                  )
                                                );
                                                a = Array.from(a);
                                              } else {
                                                a = Array.from(a);
                                                a = a.filter(
                                                  item =>
                                                    item !=
                                                    currentItem.destiny.replace(
                                                      "/",
                                                      ""
                                                    )
                                                );
                                              }
                                              return a;
                                            })()
                                          };
                                          return (({
                                            variable,
                                            value,
                                            startIndex,
                                            deleteCount
                                          }) => {
                                            if (!variable) {
                                              return;
                                            }
                                            const { objRoot, variablePath } =
                                              variable;

                                            $stateSet(
                                              objRoot,
                                              variablePath,
                                              value
                                            );
                                            return value;
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["updateTest"] != null &&
                                      typeof $steps["updateTest"] ===
                                        "object" &&
                                      typeof $steps["updateTest"].then ===
                                        "function"
                                    ) {
                                      $steps["updateTest"] =
                                        await $steps["updateTest"];
                                    }
                                  }).apply(null, eventArgs);
                                }
                              };
                              initializeCodeComponentStates(
                                $state,
                                [
                                  {
                                    name: "checked",
                                    plasmicStateName: "checkbox[].checked"
                                  }
                                ],
                                [__plasmic_idx_0],
                                undefined ?? {},
                                child$Props
                              );
                              initializePlasmicStates(
                                $state,
                                [
                                  {
                                    name: "checkbox[].checked",
                                    initFunc: ({
                                      $props,
                                      $state,
                                      $queries,
                                      $q
                                    }) =>
                                      (() => {
                                        try {
                                          return (() => {
                                            let a =
                                              $state.userPrefs.hiddenMenus ??
                                              [];
                                            let answer = a.findIndex(
                                              item =>
                                                item ==
                                                currentItem.destiny.replace(
                                                  "/",
                                                  ""
                                                )
                                            );
                                            return answer != -1;
                                          })();
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return false;
                                          }
                                          throw e;
                                        }
                                      })()
                                  }
                                ],
                                [__plasmic_idx_0]
                              );
                              return (
                                <AntdCheckbox
                                  data-plasmic-name={"checkbox"}
                                  data-plasmic-override={overrides.checkbox}
                                  {...child$Props}
                                />
                              );
                            })()
                          : null}
                        <LinkCard
                          data-plasmic-name={"linkCard"}
                          data-plasmic-override={overrides.linkCard}
                          className={classNames(
                            "__wab_instance",
                            sty.linkCard,
                            {
                              [sty.linkCardtopBar]: hasVariant(
                                $state,
                                "topBar",
                                "topBar"
                              )
                            }
                          )}
                          currentItem={currentItem}
                        />
                      </div>
                    );
                  })}
                  <div
                    className={classNames("all", sty.freeBox__aMiuE, {
                      [sty.freeBoxtopBar__aMiuEpc8We]: hasVariant(
                        $state,
                        "topBar",
                        "topBar"
                      )
                    })}
                    onClick={async event => {
                      const $steps = {};

                      $steps["updateEditMode"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["editMode"]
                              },
                              operation: 4
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              const oldValue = $stateGet(objRoot, variablePath);
                              $stateSet(objRoot, variablePath, !oldValue);
                              return !oldValue;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateEditMode"] != null &&
                        typeof $steps["updateEditMode"] === "object" &&
                        typeof $steps["updateEditMode"].then === "function"
                      ) {
                        $steps["updateEditMode"] =
                          await $steps["updateEditMode"];
                      }

                      $steps["runCode"] = !$state.editMode
                        ? (() => {
                            const actionArgs = {
                              customFunction: async () => {
                                return (() => {
                                  function saveUserPrefs(tab) {
                                    if (typeof window === "undefined") {
                                      console.log(
                                        "Not running in a browser environment."
                                      );
                                      return;
                                    }
                                    let userPrefs =
                                      localStorage.getItem("UserPrefs");
                                    userPrefs = userPrefs
                                      ? JSON.parse(userPrefs)
                                      : {};
                                    userPrefs.hiddenMenus = tab;
                                    localStorage.setItem(
                                      "UserPrefs",
                                      JSON.stringify(userPrefs)
                                    );
                                    console.log(
                                      "UserPrefs updated:",
                                      userPrefs
                                    );
                                  }
                                  return saveUserPrefs($state.test);
                                })();
                              }
                            };
                            return (({ customFunction }) => {
                              return customFunction();
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["runCode"] != null &&
                        typeof $steps["runCode"] === "object" &&
                        typeof $steps["runCode"].then === "function"
                      ) {
                        $steps["runCode"] = await $steps["runCode"];
                      }
                    }}
                  >
                    {(() => {
                      try {
                        return !$state.editMode;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <CogGearSvgrepoComSvgIcon
                        className={classNames("all", sty.svg__t3Aj7)}
                        role={"img"}
                      />
                    ) : null}
                    {(() => {
                      try {
                        return $state.editMode;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <CheckSvgIcon
                        className={classNames("all", sty.svg__oUa8P)}
                        role={"img"}
                      />
                    ) : null}
                  </div>
                </nav>
              ) : null}
              {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                (() => {
                  try {
                    return (() => {
                      let mydefault = [
                        "account",
                        "home",
                        "receiving",
                        "receiving-2",
                        "battery",
                        "rework",
                        "hsw",
                        "glass",
                        "polish-plus",
                        "polish-pro",
                        "polish-back",
                        "polish",
                        "project",
                        "paint",
                        "body",
                        "body-sand",
                        "search",
                        "packing",
                        "reprint",
                        "phone-parts",
                        "technician",
                        "daily-report",
                        "see-reports",
                        "assign-jobs",
                        "bins-overview",
                        "my-bins",
                        "bin-creation",
                        "repair-summary",
                        "grading",
                        "calendar",
                        "outside-repair",
                        "supplies",
                        "manage-users",
                        "manage-employees",
                        "timesheet",
                        "searching-bodies",
                        "employee-repair",
                        "vacation-form",
                        "technician-damages",
                        "moe",
                        "rocio-panel",
                        "access"
                      ];

                      mydefault = !$state.editMode
                        ? mydefault.filter(item => !$state.test.includes(item))
                        : mydefault;
                      const resolved = $ctx.layout ?? {};
                      const accessList = resolved.panel_access?.includes("*")
                        ? mydefault
                        : (resolved.panel_access?.filter(p =>
                            mydefault.includes(p)
                          ) ?? []);
                      function formatter(str) {
                        if (!str || str.trim() === "") return "Home";
                        return str
                          .replace(/&/g, " & ")
                          .replace(/-/g, " ")
                          .split(/\s+/)
                          .map(
                            word => word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ");
                      }
                      function buildPanelObject(item) {
                        return {
                          destiny: "/" + item,
                          preview: "/" + item,
                          title: formatter(item).replace("Reports", "Tickets"),
                          props: resolved?.panel_access_data?.[item] ?? {}
                        };
                      }
                      const definedGroups = [
                        {
                          title: "Receiving",
                          expectedPanels: [
                            "receiving",
                            "receiving-2",
                            "packing"
                          ]
                        },
                        {
                          title: "Work panels",
                          expectedPanels: [
                            "battery",
                            "rework",
                            "glass",
                            "polish-plus",
                            "polish-pro",
                            "polish-back",
                            "polish",
                            "paint",
                            "body",
                            "body-sand",
                            "project",
                            "hsw"
                          ]
                        },
                        {
                          title: "Reports",
                          expectedPanels: [
                            "daily-report",
                            "see-ticket",
                            "see-reports",
                            "repair-summary"
                          ]
                        },
                        {
                          title: "Managing",
                          expectedPanels: [
                            "assign-jobs",
                            "manage-users",
                            "manage-employees",
                            "phone-parts",
                            "employee-repair",
                            "rocio-panel"
                          ]
                        },
                        {
                          title: "Bins",
                          expectedPanels: [
                            "bin-creation",
                            "my-bins",
                            "bins-overview"
                          ]
                        },
                        {
                          title: "Misc",
                          expectedPanels: [
                            "grading",
                            "calendar",
                            "outside-repair",
                            "supplies",
                            "timesheet",
                            "vacation-form",
                            "moe"
                          ]
                        }
                      ];

                      const baseIndividualPanels = [
                        "account",
                        "home",
                        "search",
                        "reprint",
                        "technician",
                        "searching-bodies",
                        "access"
                      ];

                      let finalIndividualIds = baseIndividualPanels.filter(p =>
                        accessList.includes(p)
                      );
                      const finalGroups = [];
                      definedGroups.forEach(group => {
                        const allowedPanels = group.expectedPanels.filter(p =>
                          accessList.includes(p)
                        );
                        if (allowedPanels.length === 1) {
                          finalIndividualIds.push(allowedPanels[0]);
                        } else if (allowedPanels.length > 1) {
                          finalGroups.push({
                            title: group.title,
                            panels: allowedPanels.map(buildPanelObject)
                          });
                        }
                      });
                      const result = [];
                      if (finalIndividualIds.length > 0) {
                        result.push({
                          title: "Individual Panels",
                          panels: finalIndividualIds.map(buildPanelObject)
                        });
                      }
                      result.push(...finalGroups);
                      return { result };
                    })();
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()
              ).map((__plasmic_item_0, __plasmic_idx_0) => {
                const currentItem = __plasmic_item_0;
                const currentIndex = __plasmic_idx_0;
                return (
                  <AntdMenu
                    data-plasmic-name={"myMenu"}
                    data-plasmic-override={overrides.myMenu}
                    className={classNames("__wab_instance", sty.myMenu, {
                      [sty.myMenutopBar]: hasVariant($state, "topBar", "topBar")
                    })}
                    defaultSelectedKeys={(() => {
                      const safeResult =
                        currentItem?.result?.find(r =>
                          r?.panels
                            ?.map(p => p?.destiny === $ctx?.pagePath)
                            ?.some(Boolean)
                        )?.title ?? null;
                      return [safeResult, $ctx?.pagePath ?? null];
                    })()}
                    key={currentIndex}
                    mode={
                      hasVariant($state, "topBar", "topBar")
                        ? "horizontal"
                        : "inline"
                    }
                    triggerSubMenuAction={"click"}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return currentItem.result.filter(
                            item => item.title != "Individual Panels"
                          );
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_1, __plasmic_idx_1) => {
                      const currentItem = __plasmic_item_1;
                      const currentIndex = __plasmic_idx_1;
                      return (
                        <AntdSubMenu
                          data-plasmic-name={"subMenu"}
                          data-plasmic-override={overrides.subMenu}
                          className={classNames("__wab_instance", sty.subMenu, {
                            [sty.subMenutopBar]: hasVariant(
                              $state,
                              "topBar",
                              "topBar"
                            )
                          })}
                          key={currentItem.title}
                          title={
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__wOghq,
                                {
                                  [sty.texttopBar__wOghqPc8We]: hasVariant(
                                    $state,
                                    "topBar",
                                    "topBar"
                                  )
                                }
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return currentItem.title;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "Sub-menu";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </div>
                          }
                        >
                          {(_par =>
                            !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return currentItem.panels;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_2, __plasmic_idx_2) => {
                            const currentItem = __plasmic_item_2;
                            const currentIndex = __plasmic_idx_2;
                            return (
                              <AntdMenuItem
                                className={classNames(
                                  "__wab_instance",
                                  sty.menuItem__zUux,
                                  {
                                    [sty.menuItemhidden__zUuxfNdQ]: hasVariant(
                                      $state,
                                      "hidden",
                                      "hidden"
                                    ),
                                    [sty.menuItemtopBar__zUuxPc8We]: hasVariant(
                                      $state,
                                      "topBar",
                                      "topBar"
                                    )
                                  }
                                )}
                                danger={false}
                                disabled={false}
                                key={(() => {
                                  try {
                                    return currentItem.destiny;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()}
                                onClick={async () => {
                                  const $steps = {};

                                  $steps["goToPage"] =
                                    currentItem.destiny != $ctx.pagePath
                                      ? (() => {
                                          const actionArgs = {
                                            destination: currentItem.destiny
                                          };
                                          return (({ destination }) => {
                                            if (
                                              typeof destination === "string" &&
                                              destination.startsWith("#")
                                            ) {
                                              document
                                                .getElementById(
                                                  destination.substr(1)
                                                )
                                                .scrollIntoView({
                                                  behavior: "smooth"
                                                });
                                            } else {
                                              __nextRouter?.push(destination);
                                            }
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                  if (
                                    $steps["goToPage"] != null &&
                                    typeof $steps["goToPage"] === "object" &&
                                    typeof $steps["goToPage"].then ===
                                      "function"
                                  ) {
                                    $steps["goToPage"] =
                                      await $steps["goToPage"];
                                  }

                                  $steps["updateLoading"] =
                                    currentItem.destiny != $ctx.pagePath
                                      ? (() => {
                                          const actionArgs = {
                                            variable: {
                                              objRoot: $state,
                                              variablePath: ["loading"]
                                            },
                                            operation: 0,
                                            value: true
                                          };
                                          return (({
                                            variable,
                                            value,
                                            startIndex,
                                            deleteCount
                                          }) => {
                                            if (!variable) {
                                              return;
                                            }
                                            const { objRoot, variablePath } =
                                              variable;

                                            $stateSet(
                                              objRoot,
                                              variablePath,
                                              value
                                            );
                                            return value;
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                  if (
                                    $steps["updateLoading"] != null &&
                                    typeof $steps["updateLoading"] ===
                                      "object" &&
                                    typeof $steps["updateLoading"].then ===
                                      "function"
                                  ) {
                                    $steps["updateLoading"] =
                                      await $steps["updateLoading"];
                                  }
                                }}
                                title={currentItem.title}
                              >
                                <div
                                  className={classNames(
                                    "all",
                                    sty.freeBox__llgW1,
                                    {
                                      [sty.freeBoxtopBar__llgW1Pc8We]:
                                        hasVariant($state, "topBar", "topBar")
                                    }
                                  )}
                                >
                                  <div
                                    className={classNames(
                                      "all",
                                      "__wab_text",
                                      sty.text__k1Max
                                    )}
                                  >
                                    <div
                                      className={"__wab_expr_html_text"}
                                      dangerouslySetInnerHTML={{
                                        __html: (() => {
                                          try {
                                            return `<a href="${currentItem.destiny}">${currentItem.title}</a>`;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "Sub-menu item 1";
                                            }
                                            throw e;
                                          }
                                        })()
                                      }}
                                    />
                                  </div>
                                  <div
                                    className={classNames(
                                      "all",
                                      sty.freeBox__q8CuD
                                    )}
                                  >
                                    {(() => {
                                      try {
                                        return currentItem.props.waiting_orders;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__ccwTx
                                        )}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center"
                                        }}
                                      >
                                        <React.Fragment>
                                          {(() => {
                                            try {
                                              return currentItem.props
                                                .waiting_orders;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "99";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        </React.Fragment>
                                      </div>
                                    ) : null}
                                    {(() => {
                                      try {
                                        return currentItem.props.pending;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__zNjeW
                                        )}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center"
                                        }}
                                      >
                                        <React.Fragment>
                                          {(() => {
                                            try {
                                              return currentItem.props.pending;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "99";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        </React.Fragment>
                                      </div>
                                    ) : null}
                                    {(() => {
                                      try {
                                        return currentItem.props.working_orders;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <div
                                        className={classNames(
                                          "all",
                                          "__wab_text",
                                          sty.text__joahh
                                        )}
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center"
                                        }}
                                      >
                                        <React.Fragment>
                                          {(() => {
                                            try {
                                              return currentItem.props
                                                .working_orders;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "99";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        </React.Fragment>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </AntdMenuItem>
                            );
                          })}
                        </AntdSubMenu>
                      );
                    })}
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return currentItem.result.find(
                            item => item.title == "Individual Panels"
                          ).panels;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_1, __plasmic_idx_1) => {
                      const currentItem = __plasmic_item_1;
                      const currentIndex = __plasmic_idx_1;
                      return (
                        <AntdMenuItem
                          className={classNames(
                            "__wab_instance",
                            sty.menuItem__nZaj9,
                            {
                              [sty.menuItemtopBar__nZaj9Pc8We]: hasVariant(
                                $state,
                                "topBar",
                                "topBar"
                              )
                            }
                          )}
                          danger={false}
                          disabled={false}
                          key={(() => {
                            try {
                              return currentItem.destiny;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          onClick={async () => {
                            const $steps = {};

                            $steps["goToPage"] =
                              currentItem.destiny != $ctx.pagePath
                                ? (() => {
                                    const actionArgs = {
                                      destination: currentItem.destiny
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        __nextRouter?.push(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                            if (
                              $steps["goToPage"] != null &&
                              typeof $steps["goToPage"] === "object" &&
                              typeof $steps["goToPage"].then === "function"
                            ) {
                              $steps["goToPage"] = await $steps["goToPage"];
                            }

                            $steps["updateLoading"] =
                              currentItem.destiny != $ctx.pagePath
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: ["loading"]
                                      },
                                      operation: 0,
                                      value: true
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                            if (
                              $steps["updateLoading"] != null &&
                              typeof $steps["updateLoading"] === "object" &&
                              typeof $steps["updateLoading"].then === "function"
                            ) {
                              $steps["updateLoading"] =
                                await $steps["updateLoading"];
                            }
                          }}
                          title={currentItem.title}
                        >
                          <div
                            className={classNames("all", sty.freeBox___21Luv)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__sDfVc
                              )}
                            >
                              <div
                                className={"__wab_expr_html_text"}
                                dangerouslySetInnerHTML={{
                                  __html: (() => {
                                    try {
                                      return `<a href="${currentItem.destiny}">${currentItem.title}</a>`;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "Sub-menu item 1";
                                      }
                                      throw e;
                                    }
                                  })()
                                }}
                              />
                            </div>
                            <div
                              className={classNames("all", sty.freeBox__kiaHf)}
                            >
                              {(() => {
                                try {
                                  return currentItem.props.waiting_orders;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })() ? (
                                <div
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.text__a7Yxj
                                  )}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                  }}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return currentItem.props.waiting_orders;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "99";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </div>
                              ) : null}
                              {(() => {
                                try {
                                  return currentItem.props.pending;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })() ? (
                                <div
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.text___8RkrQ
                                  )}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                  }}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return currentItem.props.pending;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "99";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </div>
                              ) : null}
                              {(() => {
                                try {
                                  return currentItem.props.working_orders;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })() ? (
                                <div
                                  className={classNames(
                                    "all",
                                    "__wab_text",
                                    sty.text__ydL5N
                                  )}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                  }}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return currentItem.props.working_orders;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "99";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </AntdMenuItem>
                      );
                    })}
                  </AntdMenu>
                );
              })}
            </div>
          ) : null}
        </div>
        <NavigationShell
          data-plasmic-name={"navigationShell"}
          data-plasmic-override={overrides.navigationShell}
          className={classNames("__wab_instance", sty.navigationShell, {
            [sty.navigationShelltopBar]: hasVariant($state, "topBar", "topBar")
          })}
          defaultCollapsed={false}
          layoutData={$ctx.layout}
          position={(() => {
            try {
              return (() => {
                let a = $ctx.layout ?? { panel_access: ["*"] };
                return !a.panel_access.includes("*") ? "top" : "left";
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "top";
              }
              throw e;
            }
          })()}
        >
          <NotificationCenter2
            className={classNames(
              "__wab_instance",
              sty.notificationCenter2__dLjhi,
              {
                [sty.notificationCenter2topBar__dLjhiPc8We]: hasVariant(
                  $state,
                  "topBar",
                  "topBar"
                )
              }
            )}
          />

          <RealtimeStatusIndicator
            className={classNames(
              "__wab_instance",
              sty.realtimeStatusIndicator__khKGo
            )}
          />

          <section
            className={classNames("all", sty.section__lwvMz, {
              [sty.sectiondarkMode__lwvMzks0If]: hasVariant(
                $state,
                "darkMode",
                "darkMode"
              ),
              [sty.sectiontopBar__lwvMzPc8We]: hasVariant(
                $state,
                "topBar",
                "topBar"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.children
            })}
          </section>
        </NavigationShell>
        <GlobalSupabaseFetchConfig
          data-plasmic-name={"globalSupabaseFetchConfigInitializer"}
          data-plasmic-override={overrides.globalSupabaseFetchConfigInitializer}
          className={classNames(
            "__wab_instance",
            sty.globalSupabaseFetchConfigInitializer,
            {
              [sty.globalSupabaseFetchConfigInitializertopBar]: hasVariant(
                $state,
                "topBar",
                "topBar"
              )
            }
          )}
        />

        {(() => {
          try {
            return $state.loading;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <div
            className={classNames("all", sty.freeBox__fcHZp, {
              [sty.freeBoxtopBar__fcHZpPc8We]: hasVariant(
                $state,
                "topBar",
                "topBar"
              )
            })}
          >
            <IconIcon
              className={classNames("all", sty.svg__fpDtA)}
              role={"img"}
            />
          </div>
        ) : null}
      </section>
      {(() => {
        try {
          return $ctx.layout?.chat_perms;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          className={classNames("all", sty.freeBox__wHqqJ)}
          style={{ pointerEvents: "none" }}
        >
          <ReportIssue
            data-plasmic-name={"reportIssue"}
            data-plasmic-override={overrides.reportIssue}
            className={classNames("__wab_instance", sty.reportIssue)}
          />

          <AiChat
            data-plasmic-name={"aiChat"}
            data-plasmic-override={overrides.aiChat}
            className={classNames("__wab_instance", sty.aiChat)}
          />
        </div>
      ) : null}
      <SideEffect
        data-plasmic-name={"sideEffect"}
        data-plasmic-override={overrides.sideEffect}
        className={classNames("__wab_instance", sty.sideEffect)}
        onMount={async () => {
          const $steps = {};

          $steps["runCode"] = true
            ? (() => {
                const actionArgs = {
                  customFunction: async () => {
                    return (function () {
                      console.log(
                        "[MC-Listener] Script loaded\u2026 waiting for DOMContentLoaded"
                      );
                      console.log(
                        "[MC-Listener] DOM ready, initializing optimized listener"
                      );
                      const target = "minecraft";
                      let buffer = "";
                      let listening = false;
                      let timeoutId = null;
                      const TIMEOUT_MS = 1500;
                      function reset(reason) {
                        console.log("[MC-Listener] Reset:", reason);
                        buffer = "";
                        listening = false;
                        if (timeoutId) clearTimeout(timeoutId);
                        timeoutId = null;
                      }
                      function startTimeout() {
                        if (timeoutId) clearTimeout(timeoutId);
                        timeoutId = setTimeout(() => {
                          reset("timeout expired");
                        }, TIMEOUT_MS);
                      }
                      window.addEventListener("keydown", e => {
                        const key = e.key?.toLowerCase();
                        if (!/^[a-z]$/.test(key)) return;
                        if (!listening) {
                          if (key === "m") {
                            listening = true;
                            buffer = "m";
                            console.log(
                              "[MC-Listener] Listening started with 'm'"
                            );
                            startTimeout();
                          }
                          return;
                        }
                        buffer += key;
                        console.log("[MC-Listener] Buffer:", buffer);
                        startTimeout();
                        if (buffer.length > target.length) {
                          buffer = buffer.slice(buffer.length - target.length);
                          console.log("[MC-Listener] Trimmed buffer:", buffer);
                        }
                        if (buffer === target) {
                          console.log(
                            "[MC-Listener] MATCH DETECTED \u2014 opening popup"
                          );
                          const popup = window.open(
                            "/mc/index.html",
                            "eaglerPopup",
                            "width=900,height=600,resizable=yes,scrollbars=no"
                          );
                          if (popup) {
                            console.log(
                              "[MC-Listener] Popup opened successfully"
                            );
                          } else {
                            console.warn(
                              "[MC-Listener] Popup blocked by browser"
                            );
                          }
                          reset("match completed");
                        }
                      });
                      console.log(
                        "[MC-Listener] Optimized listener initialized"
                      );
                    })();
                  }
                };
                return (({ customFunction }) => {
                  return customFunction();
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runCode"] != null &&
            typeof $steps["runCode"] === "object" &&
            typeof $steps["runCode"].then === "function"
          ) {
            $steps["runCode"] = await $steps["runCode"];
          }
        }}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "container",
    "h5",
    "supabaseRpcProvider",
    "button",
    "customer",
    "checkbox",
    "linkCard",
    "myMenu",
    "subMenu",
    "navigationShell",
    "globalSupabaseFetchConfigInitializer",
    "reportIssue",
    "aiChat",
    "sideEffect"
  ],
  container: [
    "container",
    "h5",
    "supabaseRpcProvider",
    "button",
    "customer",
    "checkbox",
    "linkCard",
    "myMenu",
    "subMenu"
  ],
  h5: ["h5"],
  supabaseRpcProvider: ["supabaseRpcProvider", "button"],
  button: ["button"],
  customer: ["customer", "checkbox", "linkCard"],
  checkbox: ["checkbox"],
  linkCard: ["linkCard"],
  myMenu: ["myMenu", "subMenu"],
  subMenu: ["subMenu"],
  navigationShell: ["navigationShell"],
  globalSupabaseFetchConfigInitializer: [
    "globalSupabaseFetchConfigInitializer"
  ],
  reportIssue: ["reportIssue"],
  aiChat: ["aiChat"],
  sideEffect: ["sideEffect"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  container: "div";
  h5: "h5";
  supabaseRpcProvider: typeof SupabaseRpcProvider;
  button: typeof AntdButton;
  customer: "nav";
  checkbox: typeof AntdCheckbox;
  linkCard: typeof LinkCard;
  myMenu: typeof AntdMenu;
  subMenu: typeof AntdSubMenu;
  navigationShell: typeof NavigationShell;
  globalSupabaseFetchConfigInitializer: typeof GlobalSupabaseFetchConfig;
  reportIssue: typeof ReportIssue;
  aiChat: typeof AiChat;
  sideEffect: typeof SideEffect;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLayout2__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLayout2__VariantsArgs;
    args?: PlasmicLayout2__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLayout2__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLayout2__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLayout2__ArgProps,
          internalVariantPropNames: PlasmicLayout2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLayout2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLayout2";
  } else {
    func.displayName = `PlasmicLayout2.${nodeName}`;
  }
  return func;
}

export const PlasmicLayout2 = Object.assign(
  // Top-level PlasmicLayout2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    h5: makeNodeComponent("h5"),
    supabaseRpcProvider: makeNodeComponent("supabaseRpcProvider"),
    button: makeNodeComponent("button"),
    customer: makeNodeComponent("customer"),
    checkbox: makeNodeComponent("checkbox"),
    linkCard: makeNodeComponent("linkCard"),
    myMenu: makeNodeComponent("myMenu"),
    subMenu: makeNodeComponent("subMenu"),
    navigationShell: makeNodeComponent("navigationShell"),
    globalSupabaseFetchConfigInitializer: makeNodeComponent(
      "globalSupabaseFetchConfigInitializer"
    ),
    reportIssue: makeNodeComponent("reportIssue"),
    aiChat: makeNodeComponent("aiChat"),
    sideEffect: makeNodeComponent("sideEffect"),

    // Metadata about props expected for PlasmicLayout2
    internalVariantProps: PlasmicLayout2__VariantProps,
    internalArgProps: PlasmicLayout2__ArgProps
  }
);

export default PlasmicLayout2;
/* prettier-ignore-end */
